import { props, formatDate } from './syllabus-block-utils';
import Block from './block';

export default {
  props,
  template: '#session-schedule-block-template',
  data() {
    return Object.assign({
      title: '',
      sessions: [],
      showDraftSessions: false,
      showSessionNumber: true,
      showSessionStart: true,
      displayMode: 'list',
      displayModes: [
        'list',
        'table'
      ],
    }, this.rootData);
  },
  components: {
    Block
  },
  watch: {
    dataForSave() {
      this.$emit('block-update', this.dataForSave);
    },
  },
  computed: {
    isEmpty() {
      return _.isEmpty(this.sessions);
    },
    renderableSessions() {
      return this.sessions.filter((s) => {
        return (s.status == 'published' || this.showDraftSessions);
      });
    },
    sessionListLines() {
      return this.renderableSessions.map((s) => {
        let line = s.title;
        if(this.showSessionNumber) {
          line = `Session ${s.order}: ${line}`;
        }
        if (this.showSessionStart && !_.isEmpty(s.start_date)) {
          line = `${line} (${formatDate(s.start_date)})`;
        }
        return line;
      });
    },
    dataForSave() {
      return {
        uuid: this.uuid,
        data: {
          title: this.title,
          showSessionNumber: this.showSessionNumber,
          showSessionStart: this.showSessionStart,
          showDraftSessions: this.showDraftSessions,
          displayMode: this.displayMode,
          showOnPublicSyllabus: this.showOnPublicSyllabus
        }
      };
    },
  },
  mounted() {
    this.sessions = this.$root.course.lectures;
  },
  methods: {
    navigateToSessions() {
      let opts = {
        title: 'Are you sure you want to leave?',
        body: `You are about to leave the Syllabus Creator to edit your
        Sessions, any changes will be saved`,
        cancel_btn_text: 'Return To Builder',
        ok_btn_text: 'Save & Continue'
      };
      const path = Kadenze.Routes.course_sessions_path(this.$root.course.id);

      Kadenze.UIUtil.confirmAction(
        opts.body, () => {
          this.$root.save(() => window.location = path);
        }, null, opts
      );
    }
  }
};
